import M from 'moment';
import LinkTitleComponent from '72cms-ui/components/table-elements/LinkTitleComponent';
import DateTimeComponent from '72cms-ui/components/table-elements/DateTimeComponent';
import CustomFilterComponent from '72cms-ui/components/helpers/CustomFilterComponent';
import DateFilterComponent from '72cms-ui/components/helpers/DateFilterComponent';
import ActiveSwitchActionComponent from '72cms-ui/components/table-elements/ActiveSwitchActionComponent';

export default {
    fields: {
        created_at: {
            label: 'Date',
            component: DateTimeComponent,
            dateFormat: 'DD MMM YYYY',
            timeFormat: 'HH:mm:ss',
            isLink: true,
        },
        subject: {
            label: 'Subject',
            component: LinkTitleComponent,
        },
        email: {
            component: {
                template: `<a class="primary" :href="'#/message/' + data.id">{{ initialValue }}</a>`,
                props: ['initialValue', 'data'],
            },
        },
        latest_status: {
			label: 'Status',
            component: {
                template: `<span :class="['badge', flavor]">{{ initialValue }}</span>`,
                props: ['initialValue'],
                computed: {
                    flavor() {
                        switch (this.initialValue) {
                            case 'delivered': return 'badge-primary';
                            case 'open': return 'badge-success';
                            case 'click': return 'badge-success';
                            case 'deferred': return 'badge-warning';
                            case 'bounce': return 'badge-danger';
                            case 'drop': return 'badge-danger';
                            default: return 'badge-default';
                        }
                    }
                }
            }
        },
    },
    sortable: ['id', 'name', 'processed_at'],
    filterable: [
        'latest_status',
    ],
    toolbar: [{
        name: 'export',
        endpoint: function(content) {
            const path = '/messages';
            const filter = _.get(content, 'meta.filter');
            const sort = 'processed_at:asc';

            return {
                path, query: {
                    filter, sort,
                    per_page: 100000,
                }
            }
        },
        formatter: function (item) {

            let fields = {
                id: item.id,
				...item.meta,
                ...item.attributes,
            }

            return fields;
        },
    }],
    customFilters: [
        {
            name: 'Date',
            component: DateFilterComponent,
            field: 'updated_at',
        },
        {
            name: 'User',
            component: CustomFilterComponent,
            key: 'user.id',
            endpoint: '/users/_ref_',
            searchable: true,
        },
    ],
    pagination: true,
    searchable: true,
    hierarchy: false,
    batchActions: ['delete'],
    actions: [
        {
            name: 'view',
            component: 'view-button',
            primary: true,
        },
        {
            name: 'delete',
            component: 'delete-button',
            primary: true,
        },
    ],
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/collection.messages.js